<template>
  <div class="card-body py-2">
    <div class="country-vs-text">
      <div class="country-vs-text__image">
        <img src="/images/logo-fpf.svg" alt="FPF">
        <b class="ml-2">Per</b>
      </div>
      <span class="country-vs-text__vs">VS</span>
      <div class="country-vs-text__image text-right">
        <b class="mr-2">{{nameVs}}</b>
        <img :src="logoVs" alt="FPF">
      </div>
    </div>
    <div class="date-gray text-center">
      <div class="d-inline-block">
        <small>
          <b>Fecha </b>
          {{date}}
        </small>
      </div>
      <div>
        <b>{{hour}}</b>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    date: String,
    hour: String,
    logoVs: String,
    nameVs: String,
  },
};
</script>
